import {Issue, IssueStatus, resolveIssue} from "../api/issue.ts";
import {FC, useMemo, useState} from "react";
import Button from "../atoms/Button.tsx";
import {ArchiveTickIcon} from "../atoms/Icon";
import SmallLoadingSpinner from "../atoms/SmallLoadingSpinner.tsx";
import {DateTime} from "luxon";

interface Props {
    issue: Issue
}

const IssueCompleteButton: FC<Props> = ({ issue }) => {
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState(issue.status);
    const [resolvedAt, setResolvedAt] = useState<number | undefined>(issue.closedAt);
    const displayResolvedDate = useMemo(() => {
        if (!resolvedAt) return '';
        return DateTime.fromMillis(resolvedAt).toFormat("ccc dd LLL HH:mm");
    }, [resolvedAt]);

    const resolve = async () => {
        setLoading(true);
        try {
            const updatedIssue = await resolveIssue(issue.siteId, issue.id);
            setStatus(updatedIssue.status);
            setResolvedAt(updatedIssue.closedAt);
        } catch (error) {
            console.error("Failed to resolve issue:", error);
        } finally {
            setLoading(false);
        }
    }

    if (loading) {
        return <Button variant="outline" size="small"><SmallLoadingSpinner /></Button>
    }

    if (status === IssueStatus.RESOLVED) {
        return <Button variant="outline" size="small" disabled>
            <ArchiveTickIcon size={20} />
            Completed {displayResolvedDate}
        </Button>
    }

    return <Button size="small" onClick={resolve}><ArchiveTickIcon size={20}/>Mark as complete</Button>
}

export default IssueCompleteButton;